export var FrequencyType;
(function (FrequencyType) {
    FrequencyType["FREQ_DAILY"] = "FREQ_DAILY";
    FrequencyType["FREQ_WEEKLY"] = "FREQ_WEEKLY";
    FrequencyType["FREQ_MONTHLY"] = "FREQ_MONTHLY";
    FrequencyType["FREQ_YEARLY"] = "FREQ_YEARLY";
})(FrequencyType || (FrequencyType = {}));
